import React from 'react';
import Alert from 'Components/Alert';
import FieldSet from 'Components/FieldSet';
import PageContent from 'Components/Page/PageContent';
import PageContentBody from 'Components/Page/PageContentBody';
import Table from 'Components/Table/Table';
import TableBody from 'Components/Table/TableBody';
import TableRow from 'Components/Table/TableRow';
import TableRowCell from '../components/TdarrTableRowCell';
import { kinds } from 'Helpers/Props';
import { useTdarrCollection } from '../queries';

const columns = [{ name: 'name', label: 'Name', isVisible: true, isSortable: false }, { name: 'id', label: 'Identifier', isVisible: true, isSortable: false }];
export default function CollectionPage({ title, collection, empty }: { title: string; collection: string; empty: string }) {
  const query = useTdarrCollection(collection);
  return <PageContent title={title}><PageContentBody><FieldSet legend={title}>
    {query.isError && <Alert kind={kinds.DANGER}>Unable to load {title.toLowerCase()}.</Alert>}
    {query.isSuccess && !query.data.length && <Alert>{empty}</Alert>}
    {!!query.data?.length && <Table columns={columns}><TableBody>{query.data.map((item) => <TableRow key={item._id}><TableRowCell>{item.name ?? item._id}</TableRowCell><TableRowCell>{item._id}</TableRowCell></TableRow>)}</TableBody></Table>}
  </FieldSet></PageContentBody></PageContent>;
}
